import Header from './Header.jsx';
import Footer from './Footer.jsx';

const Layout = ({ children }) => {
    return (
      <>
        <Header />
        <div className="min-h-screen flex flex-col bg-white">
          <div className="flex-grow pt-16 lg:pt-20">{children}</div>
          <Footer />
        </div>
      </>
    );
};

export default Layout;